(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mfcs-enquiry-routing"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-mfcs-enquiry-router]');
  if (!config) return;
  const destination = config.dataset.callbackUrl;
  const routeAnchor = (anchor) => {
    const raw = anchor.getAttribute('href');
    if (!raw) return;
    let url;
    try { url = new URL(raw, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    const isContact = url.pathname.endsWith('/pages/contact') || url.pathname.endsWith('/pages/contact/');
    const isQuote = url.hash === '#quote-section' && ((url.pathname.endsWith('/pages/solutions') || url.pathname.endsWith('/pages/solutions/')) || raw === '#quote-section');
    if ((isContact && url.searchParams.get('view') !== 'callback') || isQuote) anchor.setAttribute('href', destination);
  };
  const routeWithin = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.('a[href]')) routeAnchor(root);
    root.querySelectorAll('a[href]').forEach(routeAnchor);
  };
  routeWithin(document);
  document.addEventListener('shopify:section:load', (event) => routeWithin(event.target));
  new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(routeWithin);
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfcs-header-search"] && !Shopify.designMode) return;
  try {
    function setupFloatingMicroforceMenu() {
  document.querySelectorAll('header-component[data-inline-search]').forEach((header) => {
    if (header.dataset.mfFloatingReady) return;
    const topRow = header.querySelector('.header__row--top');
    if (!topRow) return;
    header.dataset.mfFloatingReady = 'true';
    const update = () => header.parentElement.style.setProperty('--mf-header-top-height', topRow.getBoundingClientRect().height + 'px');
    const observer = new ResizeObserver(update);
    observer.observe(topRow);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupFloatingMicroforceMenu, {once:true});
else setupFloatingMicroforceMenu();
document.addEventListener('shopify:section:load', setupFloatingMicroforceMenu);

function setupMicroforceFloatingControls() {
  document.querySelectorAll('header-component[data-inline-search]').forEach((header) => {
    if (header.dataset.mfControlsReady) return;
    const top = header.querySelector('.header__row--top');
    const bottom = header.querySelector('.header__row--bottom .header__columns');
    const logo = top?.querySelector('.header-logo');
    const actions = top?.querySelector('header-actions');
    if (!bottom || !logo || !actions) return;
    header.dataset.mfControlsReady = 'true';
    const logoHome = document.createComment('logo-position');
    const actionsHome = document.createComment('actions-position');
    logo.before(logoHome);
    actions.before(actionsHome);
    const brandSlot = document.createElement('div');
    brandSlot.className = 'mf-floating-brand';
    const actionsSlot = document.createElement('div');
    actionsSlot.className = 'mf-floating-actions';
    bottom.prepend(brandSlot);
    bottom.append(actionsSlot);
    const desktop = matchMedia('(min-width:990px)');
    const update = () => {
      const shouldFloat = desktop.matches && header.dataset.stickyState === 'active' && header.dataset.menuStyle !== 'drawer';
      if (shouldFloat === header.hasAttribute('data-mf-controls-floating')) return;
      if (shouldFloat) {
        top.style.minHeight = top.getBoundingClientRect().height + 'px';
        header.setAttribute('data-mf-controls-floating','');
        brandSlot.append(logo);
        actionsSlot.append(actions);
      } else {
        logoHome.after(logo);
        actionsHome.after(actions);
        header.removeAttribute('data-mf-controls-floating');
        top.style.removeProperty('min-height');
      }
    };
    new MutationObserver(update).observe(header,{attributes:true,attributeFilter:['data-sticky-state','data-menu-style']});
    desktop.addEventListener('change',update);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setupMicroforceFloatingControls,{once:true});
else setupMicroforceFloatingControls();
document.addEventListener('shopify:section:load',setupMicroforceFloatingControls);
  } catch(e) { console.error(e); }
})();

})();
